import { PublicHomeTemplateType } from 'rev-portal/branding/BrandingSettings.Contract';
import { AppType } from 'rev-shared/contract/AppType';

/**
 * The BootstrapContext object is static configuration data that is loaded with the page.
 * use UserContextService, or getLocale(), etc.., instead of BootstrapContext.
 */
export interface IBootstrapContext {
	account: IBootstrapAccount;
	analyticsUrl: string;
	accessControl: string;
	app: AppType;
	baseCdnUrl: string;
	baseDistUrl: string;
	bcp47Locale: string;
	ckEditorLocale: string;
	debug: boolean;
	distUrl: string,
	enableEmbedPopupAuth: boolean;
	environmentGoogleAnalyticsEnabled: boolean;
	fullcalendarLocale: string;
	geoMapsUrl: string;
	googleAnalyticsTrackingCode: string;
	language: string;
	languagePreferenceOrder: string[];
	momentLocale: string;
	playlistId?: string;
	roles: string[];
	rootHostName: string;
	ssoEnabled: boolean;
	oidcEnabled: boolean;
	thumbnailUri: string;
	uniqueId?: string;
	user: any;
	userLocation: string;
	userLocationTimeoutMs: number;
	userIp?: string;
	videoId?: string;
	webcastId?: string;
	tokenParam?: string;
	branding?: IBootstrapBranding
	previewMetadata?: IBootstrapPreviewMetadata;
	rampDistributionAllowed: boolean;
	aiServiceEnabled: boolean;
	aiMetadataGenerationEnabled: boolean;
	aiVideoAssistantEnabled: boolean;
	aiContentAnalysisEnabled: boolean;
	aiAnswerEngineEnabled: boolean;
	enableAzureAdScim: boolean;
	editorMultiSource: boolean;
	systemLanguages?: ISystemLanguages;
	defaultFavicon: string;
	defaultScaledFavicons: Map<string, string>;
	defaultSystemTitle: string;
	lmsSaveIntervalInSec: number;
	isGuestMode?: boolean;
	guestHomeTemplate?: PublicHomeTemplateType;
}

export interface ISystemLanguages {
	account?: string;
	user?: string,
	headers: string[],
	_default: string,
}

export interface IBootstrapAccount {
	id: string;
	name: string;
	language: any;
	isRootAccount: boolean;
	hostname: string;
	googleAnalyticsDisabled: boolean;
	readonlyUserProfile: boolean;
	isUniversalEcdn: boolean;
}

export interface IBootstrapBranding {
	headerColor: string;
	headerFontColor: string;
	primaryFontColor: string;
	accentColor: string;
	accentFontColor: string;
	primaryColor: string;
	logoUri: string;
}

export interface IBootstrapPreviewMetadata {
	backgroundUri: string;
	title: string;
	hostName: string;
	description: string;
}

/**
 * vbrickBootstrapContext  contains info that can be shared in the CDN cache and served to other people. It is hard coded in a script tag in the entry html page.
 * vbrickAuxBootstrapContext is not cached, contains any personalized info
 */
const { vbrickBootstrapContext, vbrickAuxBootstrapContext } = window as any;

if(!vbrickBootstrapContext || !vbrickAuxBootstrapContext) {
	console.error('Missing boostrap context. Unable to continue.');
	throw new Error('missingBootstrapContext');
}

export const BootstrapContext: IBootstrapContext = {
	...vbrickBootstrapContext,
	...vbrickAuxBootstrapContext
};

export const DistUrl = BootstrapContext.distUrl.endsWith('/') ? BootstrapContext.distUrl : `${BootstrapContext.distUrl}/`;
export const localDistUrl = window.location.origin +
	BootstrapContext.baseDistUrl +
	(BootstrapContext.baseDistUrl.endsWith('/') ? '' : '/');
